<template>
    <ion-page>
        <ion-header>
            <ion-toolbar>
                <ion-buttons slot="start">
                    <ion-menu-button></ion-menu-button>
                </ion-buttons>
                <ion-title>Settings</ion-title>
            </ion-toolbar>
        </ion-header>
        <ion-content :fullscreen="true">
            <ion-header collapse="condense">
                <ion-toolbar>
                    <ion-title size="large">Settings</ion-title>
                </ion-toolbar>
            </ion-header>
            <!-- <ion-list class="ion-margin-top ion-padding-end">
                <ion-item @click="$router.push({ name: 'zones' })">
                    <ion-label>Aree</ion-label>
                     <ion-icon slot="end" :icon="logOutOutline"></ion-icon>
                </ion-item>
            </ion-list> -->
            <div v-if="versionNumber" class="ion-padding ion-text-right">
                <ion-note>Versione: {{ versionNumber }}</ion-note>
            </div>
            <div style="display: flex; justify-content: end; align-items: center; margin-top: 60px">
                <ion-button fill="clear" @click="logOut" color="danger">
                    <ion-icon slot="start" :icon="logOutOutline"></ion-icon>
                    Logout
                </ion-button>
            </div>
        </ion-content>
    </ion-page>
</template>

<script setup lang="ts">
import {
    IonList,
    IonNote,
    IonLabel,
    IonIcon,
    IonItem,
    IonPage,
    IonButton,
    IonHeader,
    IonToolbar,
    IonTitle,
    IonContent,
    IonButtons,
    IonMenuButton,
} from "@ionic/vue";
import { logOutOutline } from "ionicons/icons";
import { getActivePinia, Pinia, Store } from "pinia";
import { useRouter } from "vue-router";
import { useAuthStore } from "@/stores/auth";
import { onMounted, ref } from "vue";
import { App } from "@capacitor/app";
import { isPlatform } from "@ionic/vue";

const router = useRouter();
const authStore = useAuthStore();
const versionNumber = ref<string | null>(null);

const loadVersion = async () => {
    try {
        if (isPlatform("android") || isPlatform("ios")) {
            const appInfo = await App.getInfo();
            versionNumber.value = `${appInfo.version} (${appInfo.build})`;
        } else {
            versionNumber.value = `${__BUILD_TIMESTAMP__}`;
        }
    } catch (error) {
        console.error("Failed to load app version:", error);
        versionNumber.value = "Unknown";
    }
};

interface ExtendedPinia extends Pinia {
    _s: Map<string, Store>;
}
const logOut = () => {
    const pinia = getActivePinia() as ExtendedPinia;

    if (!pinia) {
        throw new Error("There is no active Pinia instance");
    }

    const resetStores: Record<string, () => void> = {};
    pinia._s.forEach((store, name) => {
        resetStores[name] = () => store.$reset();
    });

    router.push({ name: "loginRoute" });
    authStore.logout();
    resetStores.all = () => pinia._s.forEach((store) => store.$reset());

    return resetStores;
};

onMounted(() => {
    loadVersion();
});
</script>
